import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en/translation.json'
import de from './locales/de/translation.json'

export const defaultNS = 'common'
export const resources = {
  en,
  de,
} as const

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    supportedLngs: ['de', 'en'],
    fallbackLng: 'de',
    defaultNS,
    resources
  })

export default i18n
